import styled, { DefaultTheme } from 'styled-components';
import Box from '../layoutComponents/Box';
import Grid, { IGridProps } from '../layoutComponents/Grid';
import { ModalKind } from '.';

interface IHeaderWrapperProps {
  kind: ModalKind;
}

/**
 * Get CSS text color for the given `kind` based on `theme`.
 */
const getTextColorByKind = (theme: DefaultTheme, kind: ModalKind): string =>
  kind === 'primary'
    ? theme.colors.state.productPrimary
    : theme.colors.state[kind];

/**
 * Wrapper for modal header.
 */
export const HeaderWrapper = styled(Box).attrs(
  (props: IHeaderWrapperProps) => ({
    paddingX: 4,
    paddingY: 3,
    boxShadow: 'xs',
    fontSize: 2,
    kind: props.kind,
    borderTopWidth: 4,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderStyle: 'solid',
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1
  })
) <IHeaderWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  min-height: 63px;
  ${({ theme, kind }) => `
    color: ${kind === 'basic'
      ? theme.colors.state.productPrimary
      : getTextColorByKind(theme, kind)
    };
    border-top-color: ${kind === 'basic'
      ? theme.colors.grayScale[0]
      : getTextColorByKind(theme, kind)
    };
  `}
`;

/**
 * Box container which houses the close icon for `Modal`
 */
export const CloseBox = styled(Grid) <
  IGridProps & React.HTMLProps<HTMLDivElement>
  >`
  appearance: none;
  border: none;
  right: -5px;
  flex: 0 0 auto;
  & > svg {
    font-size: ${({ theme }) => theme.fontSizes[7]}px;
  }

  &:hover {
    cursor: pointer;
  }
`;

/**
 * Modal header icon wrapper.
 */
export const IconWrapper = styled.div`
  margin-right: 10px;
  & > svg {
    display: inline-block;
    vertical-align: middle;

    /* Offset for weird SVG icon height */
    margin-bottom: 2px;
  }
`;
